<ng-container [formGroup]="form">
  <div
    class="control"
    (click)="onClick()"
    [attr.disabled]="control.disabled ? 'disabled' : ''"
    [attr.isSelected]="isSelected ? 'selected' : 'none-selected'"
  >
    <ng-template [ngTemplateOutlet]="customTemplate || defaultTemplate" [ngTemplateOutletContext]="{isSelected : isSelected}"></ng-template>
  </div>

  <ng-template #defaultTemplate>
    <div class="control-item">
      <mat-icon *ngIf="defaultControlTemplate?.icon">{{defaultControlTemplate?.icon}}</mat-icon>
      <img *ngIf="defaultControlTemplate?.image" [src]="defaultControlTemplate?.image" alt="" />
      <span>{{defaultControlTemplate?.text}}</span>
    </div>
  </ng-template>
</ng-container>
